import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetUniversalSearchData } from '../vlp/services/UsersService';

// Async thunk to load search data with date range
export const fetchSearchData = createAsyncThunk(
  'search/fetchAll',
  async ({ fromDate, toDate }, { rejectWithValue }) => {
    try {
      const response = await GetUniversalSearchData(fromDate, toDate);
      const searchData = response && response.results ? response.results : response;
      return searchData || [];
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to fetch search data');
    }
  }
);

const initialState = {
  data: [],          // array of SearchDto objects { id, title, type }
  status: 'idle',    // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  lastSearchParams: null, // Track last search parameters to prevent duplicate calls
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchData: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearSearchData: (state) => {
      state.data = [];
      state.status = 'idle';
      state.error = null;
      state.lastSearchParams = null;
    },
    setLastSearchParams: (state, action) => {
      state.lastSearchParams = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchData.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
        // Store the search parameters
        state.lastSearchParams = action.meta.arg;
      })
      .addCase(fetchSearchData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSearchData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { setSearchData, clearSearchData, setLastSearchParams } = searchSlice.actions;

// Selectors
export const selectSearchData = (state) => state.search.data;
export const selectSearchStatus = (state) => state.search.status;
export const selectSearchError = (state) => state.search.error;
export const selectLastSearchParams = (state) => state.search.lastSearchParams;

export default searchSlice.reducer;